export default {
  props: {
    vital: {},
  },
};
